"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMonthsOfYearList = void 0;
const types_1 = require("../types");
const getMonthsOfYearList = () => {
    return [
        types_1.MONTH_OF_YEAR.january,
        types_1.MONTH_OF_YEAR.february,
        types_1.MONTH_OF_YEAR.march,
        types_1.MONTH_OF_YEAR.april,
        types_1.MONTH_OF_YEAR.may,
        types_1.MONTH_OF_YEAR.june,
        types_1.MONTH_OF_YEAR.july,
        types_1.MONTH_OF_YEAR.august,
        types_1.MONTH_OF_YEAR.september,
        types_1.MONTH_OF_YEAR.october,
        types_1.MONTH_OF_YEAR.november,
        types_1.MONTH_OF_YEAR.december,
    ];
};
exports.getMonthsOfYearList = getMonthsOfYearList;
//# sourceMappingURL=getMonthsOfYearList.js.map